module.exports = __webpack_public_path__ + "img/pc-button-text-right-03.a60a5544.svg";